module.exports = __webpack_public_path__ + "static/img/left-dir.5cddc20a.svg";